<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberInvalidPlanModalDialogClose' type="button" class="close" data-dismiss="modal"
          aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2 class="modal-title">Web Profile for Member {{ webProfile?.codeId }}</h2>
      </div>
      <div class="modal-body">
        <div class="split">
          <div class="split-col">
            <div>
              <h3>Details</h3>
              <div class="data-field">
                <label for="web-profile-codeId"><strong>Code ID:</strong></label>
                <span id="web-profile-codeId"><code>{{ webProfile?.codeId }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-employer"><strong>Employer:</strong></label>
                <span id="web-profile-employer">{{ webProfile?.employer || '-' }}</span>
              </div>
              <div class="data-field">
                <label for="web-profile-jobTitle"><strong>Job Title:</strong></label>
                <span id="web-profile-jobTitle">{{ webProfile?.jobTitle || '-' }}</span>
              </div>
              <div class="data-field">
                <label for="web-profile-promoCodeId"><strong>Promo Code ID:</strong></label>
                <span id="web-profile-promoCodeId"><code>{{ webProfile?.promoCodeId || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-promoCode"><strong>Promo Code:</strong></label>
                <span id="web-profile-promoCode"><code>{{ webProfile?.promoCode || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-proofResourceId"><strong>Proof Resource ID:</strong></label>
                <span id="web-profile-proofResourceId"><code>{{ webProfile?.proofResourceId || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-planId"><strong>Plan ID:</strong></label>
                <span id="web-profile-planId"><code>{{ webProfile?.planId || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-redemptionsCount"><strong>Redemptions Count:</strong></label>
                <span id="web-profile-redemptionsCount">{{ webProfile?.redemptionsCount || '0' }}</span>
              </div>
              <div class="data-field">
                <label for="web-profile-hasMobileApp"><strong>Mobile App:</strong></label>
                <span id="web-profile-hasMobileApp">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.hasMobileApp" />
                </span>
              </div>
            </div>
            <div>
              <h3>Status</h3>
              <div class="data-field">
                <label for="web-profile-status"><strong>Status:</strong></label>
                <span id="web-profile-status"><code>{{ webProfile?.status || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-profileStatus"><strong>Profile Status:</strong></label>
                <span id="web-profile-profileStatus"><code>{{ webProfile?.profileStatus || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-lastStripeError"><strong>Last Stripe Error:</strong></label>
                <span id="web-profile-lastStripeError"><code>{{ webProfile?.lastStripeError || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-proofOfEmploymentStatus"><strong>Proof of Employment Status:</strong></label>
                <span
                  id="web-profile-proofOfEmploymentStatus"><code>{{ webProfile?.proofOfEmploymentStatus || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-registrationStatus"><strong>Registration Status:</strong></label>
                <span
                  id="web-profile-registrationStatus"><code>{{ webProfile?.registrationStatus || '-' }}</code></span>
              </div>
            </div>
          </div>
          <div class="split-col">
            <div>
              <h3>Categories</h3>
              <div class="data-field">
                <label for="web-profile-isVip"><strong>VIP:</strong></label>
                <span id="web-profile-isVip">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.isVip" />
                </span>
              </div>
              <div class="data-field">
                <label for="web-profile-isFree"><strong>Free:</strong></label>
                <span id="web-profile-isFree">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.isFree" />
                </span>
              </div>
              <div class="data-field">
                <label for="web-profile-isValidated"><strong>Validated:</strong></label>
                <span id="web-profile-isValidated">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.isValidated" />
                </span>
              </div>
              <div class="data-field">
                <label for="web-profile-isStaff"><strong>Staff:</strong></label>
                <span id="web-profile-isStaff">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.isStaff" />
                </span>
              </div>
              <div class="data-field">
                <label for="web-profile-isOld"><strong>Old:</strong></label>
                <span id="web-profile-isOld">
                  <input type="checkbox" [disabled]="true" [(ngModel)]="webProfile && webProfile.isOld" />
                </span>
              </div>
            </div>
            <div>
              <h3>Subscription</h3>
              <div class="data-field">
                <label for="web-profile-lastSubscriptionType"><strong>Last Subscription Type:</strong></label>
                <span
                  id="web-profile-lastSubscriptionType"><code>{{ webProfile?.lastSubscriptionType || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-lastSubscriptionPromoCode"><strong>Last Subscription Promo
                    Code:</strong></label>
                <span
                  id="web-profile-lastSubscriptionPromoCode"><code>{{ webProfile?.lastSubscriptionPromoCode || '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-subscriptionName"><strong>Subscription Name:</strong></label>
                <span id="web-profile-subscriptionName">{{ webProfile?.subscriptionName || '-' }}</span>
              </div>
              <div class="data-field">
                <label for="web-profile-subscriptionEndDate"><strong>Subscription End Date:</strong></label>
                <span id="web-profile-subscriptionEndDate"><code>{{ (webProfile?.subscriptionEndDate) ? (webProfile?.subscriptionEndDate | dateFormat) : '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-freeTrialEndDate"><strong>Free Trial End Date:</strong></label>
                <span id="web-profile-freeTrialEndDate"><code>{{ (webProfile?.freeTrialEndDate) ? (webProfile?.freeTrialEndDate | dateFormat) : '-' }}</code></span>
              </div>
              <div class="data-field">
                <label for="web-profile-subscriptionCancelledDate"><strong>Subscription Cancelled Date:</strong></label>
                <span id="web-profile-subscriptionCancelledDate"><code>{{ (webProfile?.subscriptionCancelledDate) ? (webProfile?.subscriptionCancelledDate | dateFormat) : '-'
                  }}</code></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='modal-actions'>
        <button id='webProfileDialogOK' type="button" data-dismiss="modal" class="btn btn-info">OK</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/web-profile-modal-dialog/web-profile-modal-dialog.component.html